import TimerSvg from '@assets/images/svg/timer.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface TimerIconProps {
    size?: number;
    color?: string;
}

export const TimerIcon: React.FC<TimerIconProps> = ({
    size = 24,
    color = '#333333',
}) => {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <TimerSvg
                width={size}
                height={size}
                color={color}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default TimerIcon;
